/**
 * StatCard - Tarjeta Estadística Reutilizable
 * Mostrar información clave de un vistazo gracias a un diseño compacto y visualmente atractivo
 * Componente para mostrar métricas y estadísticas de forma visual
 */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  color = 'info', 
  onClick 
}) => {
  return (
    <Card
      sx={{
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        '&:hover': onClick ? {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        } : {},
      }}
      onClick={onClick}
    >
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center">
          <MDBox>
            <MDTypography variant="h6" fontWeight="medium" color="text">
              {title}
            </MDTypography>
            <MDTypography variant="h3" fontWeight="bold" mt={1}>
              {value}
            </MDTypography>
            {subtitle && (
              <MDTypography variant="button" color="text" fontWeight="regular">
                {subtitle}
              </MDTypography>
            )}
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="4rem"
            height="4rem"
            borderRadius="md"
            bgColor={color}
            color="white"
            fontSize="2rem"
            sx={{ boxShadow: 2 }}
          >
            <Icon fontSize="inherit">{icon}</Icon>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    'primary', 
    'secondary', 
    'info', 
    'success', 
    'warning', 
    'error', 
    'dark', 
    'light'
  ]),
  onClick: PropTypes.func,
};

export default StatCard;
